import { useEffect, useRef } from "react";
import { HubConnectionBuilder, HubConnection } from "@microsoft/signalr";
import { useAuth } from "providers/CustomAuthProvider";
import getConfig from "config";


interface INotificationHubProps {
  children: React.ReactNode;
  onReceived: (data: any) => void;
}

const NotificationHub: React.FC<INotificationHubProps> = ({
  children,
  onReceived,
}) => {
  const connectionRef = useRef<HubConnection | null>(null);
  const { accessToken } = useAuth();

  useEffect(() => {
    if (!accessToken) return;

    const connection = new HubConnectionBuilder()
      .withUrl(`${getConfig().apiUrl}/notifications-alerts`, {
        accessTokenFactory: () => accessToken,
      })
      .withAutomaticReconnect()
      .build();

    connectionRef.current = connection;

    const startConnection = async () => {
      try {
        await connection.start();
        console.log("SignalR Connected!");

        // Notification Receive
        connection.on("NotificationReceive", (response) => {
          onReceived(response);
        });

        // Sync Notifications
        connection.on("SyncNotifications", async () => {
          const data = await connection.invoke("GetUnreadNotifications");
          onReceived(data);
        });

        // Export Status
        connection.on("ReceiveMessage", (methodName, message) => {
          if (methodName === "OnExportStatus") {
            onReceived(message);
          }
        });

      } catch (err) {
        console.error("SignalR Connection Error:", err);
      }
    };

    startConnection();

    // Cleanup on unmount / token change
    return () => {
      connection.stop();
      console.log("SignalR Disconnected");
    };

  }, [accessToken]);

  return <>{children}</>;
};

export default NotificationHub;